export default __webpack_public_path__ + "static/5-51f67a1b23bbcb819cfdad74f23f9631.jpeg";